const digest = '080a79b6d2acb3a54b8b82267e9c0dda9ab6f88cdee6e0814e3c55abd6cdadc2';
const css = `._header_j2o66_1{min-width:100%}._headerInner_j2o66_5{display:flex;justify-content:space-between;margin:1rem 2rem;min-height:5rem;padding:1rem 10px 0}._modalHeaderInner_j2o66_13{display:flex;justify-content:space-between;padding:10px}._amexLogo_j2o66_19{margin:0;max-width:100%;min-width:3.75rem}._amazonFigure_j2o66_25{min-width:17.188rem;padding-top:1rem}@media (max-width:63.875rem){._headerInner_j2o66_5{padding:1rem 1.125rem 0 1.25rem}}@media (max-width:41.25rem){._headerInner_j2o66_5{padding:0 .8rem}._amexLogo_j2o66_19{max-width:3.75rem;padding-top:.6rem}._amazonFigure_j2o66_25{min-width:12.188rem;padding-top:2rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'header': '_header_j2o66_1', 'headerInner': '_headerInner_j2o66_5', 'modalHeaderInner': '_modalHeaderInner_j2o66_13', 'amexLogo': '_amexLogo_j2o66_19', 'amazonFigure': '_amazonFigure_j2o66_25' };
export const header = '_header_j2o66_1';
export const headerInner = '_headerInner_j2o66_5';
export const modalHeaderInner = '_modalHeaderInner_j2o66_13';
export const amexLogo = '_amexLogo_j2o66_19';
export const amazonFigure = '_amazonFigure_j2o66_25';
export { css, digest };